import { useEffect, useState } from 'react';

import { Spinner } from '@/components/loaders/Spinner';

interface LegacyModuleFrameProps {
  src: string;
}

export default function LegacyModuleFrame({ src }: LegacyModuleFrameProps) {
  const [isLoading, setIsLoading] = useState(true);

  const resetLoading = () => {
    // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect
    setIsLoading(true);
  };

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('legacy module frame src', src);
    resetLoading();
  }, [src]);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="relative min-h-full">
      {isLoading && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-white">
          <Spinner />
        </div>
      )}
      {/* eslint-disable @eslint-react/dom/no-missing-iframe-sandbox */}
      <iframe
        className="block h-full min-h-[calc(100vh-64px)] w-full border-none"
        src={src}
        title="Legacy Module"
        onLoad={handleIframeLoad}
      />
    </div>
  );
}
